import styled from "styled-components";
import Logo from "../../../../assets/images/logo.svg";
import { useContext } from "react";
import TransactionContext from "../../../../Contexts/Transaction";

const NewVersion = () => {
  const checkNewVersion = useContext(TransactionContext);
  return (
    <StyledWrapper className="modal_item">
      <StyledInfo>
        <StyledHeaderInfo>
          <h3>
            Flashift has launched 
            <br />a new version!
            <br />
            The old version will 
            <br />be retired on <u>January 1st.</u>
            <br />
            <br />
            Check it out now.
          </h3>
          <img src={Logo} alt="flashift" width="150px" />
        </StyledHeaderInfo>
        <StyledButton>
          <a href="https://exchangev3.flashift.app" target="_blank">
            Try New Platform
          </a>
          <button onClick={checkNewVersion.HandleCloseNewVersion}>
            Stay Here
          </button>
        </StyledButton>
      </StyledInfo>
    </StyledWrapper>
  );
};

export default NewVersion;
const StyledWrapper = styled.div`
  color: ${(props) => props.theme.color.ColorTwo};
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  padding: 20px;
  z-index: 1;
  overflow: auto;
`;
const StyledInfo = styled.div`
  background: ${(props) => props.theme.color.ColorSix};
  border-radius: ${(props) => props.theme.radius.RadiusOne};
  position: absolute;
  top: 20vh;
  left: calc(50vw - 225px);
  width: 500px;
  padding: 40px 30px 30px 30px;
  @media (max-width: 1300px) {
    left: 5%;
    width: 90%;
  }
  @media (max-width: 992px) {
    left: 4%;
    width: 92%;
    padding: 10px;
  }
`;
const StyledHeaderInfo = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  position: relative;
  top: -10px;
  img {
    margin-top: 0;
    order: 2;
  }
  h3 {
    line-height: 33px;
    order: 1;
  }
  @media (max-width: 1300px) {
    top: 0;
    img {
      margin-top: 0;
    }
  }
  @media (max-width: 480px) {
    text-align: center;
    width: 100%;
    img {
      order: 1;
      margin: 0 auto;
    }
    h3 {
      order: 2;
      width: 100%;
      position: relative;
      top: -4px;
      margin-bottom: 5px;
    }
  }
`;

const StyledButton = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  gap: 15px;
  padding-top: 30px;
  a {
    padding: 10px 40px;
    font-size: 1.1rem;
    border-radius: ${(props) => props.theme.radius.RadiusThree};
    background: #f39c12;
    color: ${(props) => props.theme.color.ColorTwo};
    text-align: center;
  }
  button {
    padding: 10px 40px;
    font-size: 1.1rem;
    border-radius: ${(props) => props.theme.radius.RadiusThree};
    background: ${(props) => props.theme.color.ColorFive};
    color: ${(props) => props.theme.color.ColorOne};
  }
  @media (max-width: 992px) {
    a {
      width: 100%;
    }
    button {
      width: 100%;
    }
  }
  @media (max-width: 480px) {
    padding-top: 0;
    button {
      margin-bottom: 10px;
    }
  }
`;
